import { cloneDeep, times } from 'lodash';
import createTaskType from '../../createTaskType';
import SpellingEditor from './Editor';

export default createTaskType({
    id: 'spelling',
    label: 'Spellings with definitions',
    skill: 'reading_writing',
    v2: true,
    hasRubric: true,

    editor: SpellingEditor,
    createItemsTemplate: () => ([
        ...times(4, createPhase1Item),
        ...times(3, createPhase2Item),
    ]),

    backgroundImages: {
        count: 3,
        description: 'Three background images are present in the Spelling task, two for the first part and one for the second part.' +
            'The first image wil be seen before and during example and item 1, while the second is seen before and during items 2 and 3, the last one is seen on example 2, and items 4 and 5.',
        configs: [
            { label: <>Background image for example 1 & item 1 <br /><br /> </> }, // 0, 1
            { label: <>Background image for items 2 & 3 <br /><br /> </> }, // 2, 3
            { label: <>Background image for example 2, items 4 & 5 <br /><br /> </> }, // 4, 5, 6
        ],
    },

    convertToLocalFormat(task) {
        task.items = task.items.map((item, index) => {
            item.index = index;
            item.page = 1;
            return item;
        })
        return task;
    },
    convertToUploadFormat(task, { isNew }) {
        task = cloneDeep(task);

        task.items = task.items.map(item => {
            delete item.index;
            delete item.page;
            return item;
        });
        delete task.final_audio_id;

        return task;
    },

    getKeys: (item) => {
        return  item.answers
        .filter(x => x.is_correct_answer)
        .map(x => (x.key ? x.key.join(', ') : x.fill_text ? x.fill_text : ''));
    }
});


function createPhase1Item(index) {
    return {
        is_example: index === 0,
        ...(index === 0 && {
            rubric_id: '',
        }),

        phase: 'DEFINITION',
        answers: [{
            is_correct_answer: true,
            fill_text: '',
            /** @type {string[]} */
            key: ['']
        }]
    };
};

const DEFAULT_ORDER = [[1, 2, 3, 4], [5], [6]];
function createPhase2Item(index) {
    const is_example = index === 0;
    return {
        phase: 'GAP_FILLING',
        page: 1,
        index: 4 + index,
        is_example,
        ...(is_example && { rubric_id: '' }),
        stimulus: '',
        answers: times(DEFAULT_ORDER[index].length, (i) => ({
            is_correct_answer: i === 0,
            fill_text: '',
            display_order: DEFAULT_ORDER[index][i]
        }))
    }
}